import React from 'react';

// 财务支持文件
const FinanceSupportFiles = () => {
    return <div>FinanceSupportFiles</div>;
};

export default FinanceSupportFiles;
